// src/services/AgendaCreateurService.jsx
// 🆕 NOUVEAU FICHIER
import { base_url } from "../utils/constante";

// ============================================================
// AGENDA DU CRÉATEUR
// ============================================================

/**
 * @param {Date} debut   Premier jour affiché
 * @param {number} jours Nombre de jours (max 92)
 */
export async function getAgendaCreateur(debut = null, jours = 31) {
    const token = localStorage.getItem("token");

    if (!token) {
        throw new Error("Non authentifié");
    }

    const d = debut || new Date();

    const debutStr = [
        d.getFullYear(),
        String(d.getMonth() + 1).padStart(2, "0"),
        String(d.getDate()).padStart(2, "0"),
    ].join("-");

    try {
        const response = await fetch(`${base_url}createur/agenda`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ debut: debutStr, jours }),
        });

        const text = await response.text();

        let data;

        try {
            data = JSON.parse(text);
        } catch (error) {
            console.error("Réponse API non JSON :", text);
            throw new Error("Réponse invalide du serveur");
        }

        if (!response.ok) {
            throw new Error(data?.message || `Erreur API ${response.status}`);
        }

        if (data?.success !== true) {
            throw new Error("Réponse inattendue de l'API");
        }

        return {
            parJour: data.evenements || {},
            compteurs: data.jours_avec_evenements || {},
            stats: data.stats || {},
            total: data.total || 0,
            debut: data.debut,
            fin: data.fin,
        };

    } catch (error) {
        console.error("Erreur getAgendaCreateur :", error);
        throw error;
    }
}

// ============================================================
// HELPERS
// ============================================================

/** Clé de date au format API : "2026-08-20" */
export const cleDate = (date) =>
    [
        date.getFullYear(),
        String(date.getMonth() + 1).padStart(2, "0"),
        String(date.getDate()).padStart(2, "0"),
    ].join("-");


/** "14:30" depuis une date ISO */
export const heureDe = (dateEven) => {
    try {
        const d = new Date(dateEven);
        return `${String(d.getHours()).padStart(2, "0")}:${String(
            d.getMinutes()
        ).padStart(2, "0")}`;
    } catch {
        return "";
    }
};